var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container reportDetail_reportItem" },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _vm.value.canEdit || _vm.value.canAnswer
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.questionsAnswer,
                      expression: "Feedback-questionsAnswer",
                    },
                  ],
                  attrs: { type: "primary", disabled: _vm.preventManyClick },
                  on: { click: _vm.save },
                },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              )
            : _vm._e(),
          _vm.value.canEdit || _vm.value.canAnswer
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.questionsAnswer,
                      expression: "Feedback-questionsAnswer",
                    },
                  ],
                  attrs: { type: "primary", disabled: _vm.preventManyClick },
                  on: { click: _vm.submit },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.submit")) + " ")]
              )
            : _vm._e(),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.goBack } },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            model: _vm.feedbackReport,
            "label-position": "right",
            "label-width": "43%",
          },
        },
        [
          _c(
            "el-card",
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.feedbackNo"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.feedbackHead.feedbackNo,
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.feedbackStatus"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("ic")(
                                _vm.feedbackHead.workflowStatus,
                                "TT_FEEDBACK",
                                "OTHER_PROCESS_NODE"
                              ),
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.reportNo"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.feedbackReport.reportNo,
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.reportType"),
                            prop: "reportType",
                          },
                        },
                        [
                          _c("IcSelect", {
                            attrs: {
                              table: "TT_FEEDBACK_REPORT",
                              field: "REPORT_TYPE",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.reportType,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "reportType", $$v)
                              },
                              expression: "feedbackReport.reportType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !(_vm.value.canEdit || _vm.taskApproval)
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storeFeedback.report.haveInterrogativeCommunication"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm._f("ic")(
                                    !!_vm.feedbackReport.answer ? "Y" : "N",
                                    "COMMON",
                                    "YES_NO"
                                  ),
                                  disabled: "",
                                  clearable: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !(_vm.value.canEdit || _vm.taskApproval)
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storeFeedback.report.doubtCommunicationStatus"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm._f("ic")(
                                    _vm.feedbackReport.answerStatus,
                                    "TT_FEEDBACK_REPORT",
                                    "QUESTION_STATUS"
                                  ),
                                  disabled: "",
                                  clearable: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.supplierCostTime"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: (
                                _vm.feedbackReport.supOperateTime / 1
                              ).toFixed(2),
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "widthReset",
                          attrs: {
                            label: _vm.$t("storeFeedback.report.remark"),
                            prop: "reportRemark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.reportRemark,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "reportRemark",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.reportRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("storeFeedback.report.basicInfo"))),
                  ]),
                ]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.receiveDate"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              value: _vm._f("dateFormatFilter")(
                                _vm.feedbackReport.receiveDate,
                                "YYYY-MM-DD"
                              ),
                              type: "date",
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.problemLevel"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value:
                                _vm.feedback.feedbackFirstCheck.problemLevel,
                              disabled: "",
                              clearable: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      !_vm.isStore
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("storeFeedback.report.deadline"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm._f("dateFormatFilter")(
                                    _vm.feedbackReport.reportDeadline,
                                    "YYYY-MM-DD HH:mm:ss"
                                  ),
                                  disabled: "",
                                  clearable: "",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      !_vm.isStore
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "storeFeedback.report.haveRejected"
                                ),
                              },
                            },
                            [
                              _vm.feedbackReport.haveRejectedByCqs
                                ? _c("el-input", {
                                    attrs: {
                                      value: _vm._f("ic")(
                                        _vm.feedbackReport.haveRejectedByCqs,
                                        "COMMON",
                                        "YES_NO"
                                      ),
                                      disabled: "",
                                      clearable: "",
                                    },
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      value: "否",
                                      disabled: "",
                                      clearable: "",
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.canContinue"),
                            prop: "canContinue",
                          },
                        },
                        [
                          _c("IcSelect", {
                            attrs: {
                              table: "COMMON",
                              field: "YES_NO",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.canContinue,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "canContinue", $$v)
                              },
                              expression: "feedbackReport.canContinue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "storeFeedback.report.sampleHandleMethod"
                            ),
                            prop: "sampleHandleMethod",
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              table: "TT_FEEDBACK_REPORT",
                              field: "SAMPLE_HANDLE_METHOD",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.sampleHandleMethod,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "sampleHandleMethod",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.sampleHandleMethod",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "storeFeedback.report.responsibleParty"
                            ),
                            prop: "responsibleParty",
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              "table-fields": _vm.responsiblePartyField,
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.responsibleParty,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "responsibleParty",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.responsibleParty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.needDebit"),
                            prop: "needDebit",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                disabled: !_vm.feedbackReport.canEdit,
                              },
                              on: { change: _vm.needDebitChange },
                              model: {
                                value: _vm.feedbackReport.needDebit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.feedbackReport, "needDebit", $$v)
                                },
                                expression: "feedbackReport.needDebit",
                              },
                            },
                            [
                              _c(
                                "el-option",
                                { attrs: { value: "Y", label: "是" } },
                                [_vm._v("是")]
                              ),
                              _c(
                                "el-option",
                                { attrs: { value: "N", label: "否" } },
                                [_vm._v("否")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.debitNumber"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              onkeyup:
                                "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                              clearable: "",
                              disabled:
                                !_vm.feedbackReport.canEdit || !_vm.isneedDebit,
                              maxLength: "9",
                            },
                            model: {
                              value: _vm.feedbackReport.debitNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "debitNumber", $$v)
                              },
                              expression: "feedbackReport.debitNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("storeFeedback.report.debitUnit"),
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              table: "TT_FEEDBACK",
                              field: "UNIT",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                            },
                            model: {
                              value: _vm.feedbackReport.debitUnit,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "debitUnit", $$v)
                              },
                              expression: "feedbackReport.debitUnit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("storeFeedback.report.reportDetail"))),
                  ]),
                ]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                            prop: "reportDetail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                              maxlength: "1000",
                            },
                            model: {
                              value: _vm.feedbackReport.reportDetail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "reportDetail",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.reportDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.DocAttachment"),
                            prop: "reportDetailDoc",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.reportDetailDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _vm.feedbackReport.canEdit
                            ? _c(
                                "el-upload",
                                {
                                  ref: "reportDetailDoc",
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.reportDetailDocUpload,
                                    multiple: "",
                                    "on-remove": _vm.reportDetailDocRemove,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.PicAttachment"),
                          },
                        },
                        [
                          _c("el-upload", {
                            staticClass: "hide",
                            attrs: {
                              "on-preview": _vm.reportDetailImgPreview,
                              disabled: "",
                              "list-type": "picture-card",
                              action: "upload",
                              "file-list": _vm.reportDetailImg,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "file",
                                fn: function ({ file }) {
                                  return _c(
                                    "div",
                                    {},
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "", disabled: "" },
                                        model: {
                                          value: file.docComments,
                                          callback: function ($$v) {
                                            _vm.$set(file, "docComments", $$v)
                                          },
                                          expression: "file.docComments",
                                        },
                                      }),
                                      _c("img", {
                                        staticClass:
                                          "el-upload-list__item-thumbnail",
                                        attrs: { src: file.url, alt: "" },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.reportDetailImgPreview(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          file.tmDocumentId
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "el-upload-list__item-delete",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.downloadFile(
                                                        file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-download",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                },
                              },
                            ]),
                          }),
                          _c(
                            "el-dialog",
                            {
                              attrs: { visible: _vm.dialogVisible },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.dialogImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("storeFeedback.report.treatment"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              clearable: "",
                              disabled: !_vm.feedbackReport.canEdit,
                              maxlength: "1000",
                            },
                            model: {
                              value: _vm.feedbackReport.treatment,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "treatment", $$v)
                              },
                              expression: "feedbackReport.treatment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.attachment"),
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.treatmentDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _vm.feedbackReport.canEdit
                            ? _c(
                                "el-upload",
                                {
                                  ref: "treatmentDoc",
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.treatmentDocUpload,
                                    multiple: "",
                                    "on-remove": _vm.treatmentDocRemove,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("storeFeedback.report.CQSAnalysis"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                            prop: "cqsAnalysis",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              row: "3",
                              autosize: "",
                              disabled: !_vm.feedbackReport.canAudit,
                              clearable: "",
                              maxlength: "1000",
                            },
                            model: {
                              value: _vm.feedbackReport.cqsAnalysis,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "cqsAnalysis", $$v)
                              },
                              expression: "feedbackReport.cqsAnalysis",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "reportForm",
          attrs: {
            model: _vm.feedbackReport,
            "label-position": "right",
            "label-width": "30%",
            rules: _vm.feedbackReportRules,
          },
        },
        [
          _c(
            "el-card",
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("storeFeedback.report.questionOfStore"))),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.feedbackReport.question,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "question", $$v)
                              },
                              expression: "feedbackReport.question",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.attachment"),
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.questionDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("storeFeedback.report.answerOfFBC"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                            prop: "answer",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              disabled: !_vm.feedbackReport.canAnswer,
                              maxlength: "1000",
                            },
                            model: {
                              value: _vm.feedbackReport.answer,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "answer", $$v)
                              },
                              expression: "feedbackReport.answer",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.attachment"),
                            prop: "answerDoc",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.answerDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.value.canEdit || _vm.value.canAnswer
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "tmDocumentId",
                                      "min-width": "130px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteFile(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.feedbackReport
                                                          .answerDoc
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("common.del"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3018243253
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.feedbackReport.canAnswer
                            ? _c(
                                "el-upload",
                                {
                                  ref: "answerDoc",
                                  attrs: {
                                    action: "answerDoc",
                                    "http-request": _vm.answerDocUpload,
                                    multiple: "",
                                    "before-upload": _vm.answerBeforeUpload,
                                    "on-remove": _vm.answerDocRemove,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }